// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___38XGM","containerIcon":"style__containerIcon___3N-jo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/chat/style.css
// module id = 401
// module chunks = 0